<button
  mat-flat-button
  color="primary"
  (click)="onClick()"
  [ngClass]="{ fullWidth: fullWidth }"
  [disabled]="disabled"
>
  {{ text | translate }}
  <span
    [ngClass]="getClass()"
  ></span>
</button>
